import Grid from "@mui/material/Grid";
import TitleCustom from "components/CustomTitle";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import Footer from "layouts/Footer";
import { useCallback, useEffect, useState } from "react";
import { reportMolecularCompoundDetail } from "rest/requests";
import { getCatalogCategoriesSync, getCatalogGroupsSync, getCatalogSectorsSync, getCatalogSubSectorsSync, getQuartersSync } from "rest/sync/requestsSync";
import DetailsDialog from "./components/DetailsDialog";
import MultipleSelectChip from "./components/multiSelectChips";
import getTableData from "./data/dataTableData";
import getGrupos from "./data/getCatalogTypeId1";
import getSector from "./data/getCatalogTypeId2";
import getSubSector from "./data/getCatalogTypeId3";
import getCategories from "./data/getCatalogTypeId6";
import getDataPorPrincipioActivo from "./data/getDataPorPrincipioActivo";
import { getExcelData } from "./data/getExcelData";

//components
// @mui material components

function PorPrincipioActivo() {
  const [compounds, setCompounds] = useState([]);

  // ------ Year select ----------
  const [year, setYear] = useState(new Date().getFullYear());
  const current_year = new Date().getFullYear();
  const handleYear = (event) => {
    const {
      target: { value },
    } = event;
    if (value <= current_year) {
      setYear(value);
    }
  };
  // ------ Year select END----------

  // ===== DATA ======
  const catalogSector = getCatalogSectorsSync();
  const catalogSubSector = getCatalogSubSectorsSync();
  const catalogGroups = getCatalogGroupsSync();
  const catalogCategories = getCatalogCategoriesSync();
  const _quarters = getQuartersSync(year);
  const quartersId = _quarters.length > 0 ? _quarters : [182, 64, 46, 47];

  // ===== DATA END======

  // ===== SECTOR ======
  const [selectedSectors, setValueSectorData] = useState([]);

  const handleSectorDataChange = (selectedValue) => {
    console.log("selectedSectors=", selectedValue);
    setValueSectorData(selectedValue);
  };
  // ===== SECTOR END ======

  // ===== SUB-SECTOR ======
  const [selectedSubSectors, setValueSubSectorData] = useState([]);

  const handleSubSectorDataChange = (selectedValue) => {
    console.log("selectedSubSectors=", selectedValue);
    setValueSubSectorData(selectedValue);
  };
  // ===== SUB-SECTOR END ======

  // ===== GRUPOS ======
  const [selectedGroups, setValueGrupoData] = useState([]);

  const handleGruposDataChange = (selectedValue) => {
    console.log("selectedGrupos=", selectedValue);
    setValueGrupoData(selectedValue);
  };

  // ===== GRUPOS END ======

  // ===== CATEGORIA ======
  const [selectedCategories, setValueCategoryData] = useState([]);

  const handleCategoryDataChange = (selectedValue) => {
    console.log("selectedCategories=", selectedValue);
    setValueCategoryData(selectedValue);
  };
  // ===== END CATEGORIA ======

  const handleUpdate = useCallback(async () => {
    let searchData = {
      year: year,
      sectorsId: selectedSectors,
      subsectorsId: selectedSubSectors,
      groupsId: selectedGroups,
      categoriesId: selectedCategories,
    };
    console.log(selectedSectors, selectedSubSectors, selectedGroups, selectedCategories, year);
    var temp = await getDataPorPrincipioActivo(searchData, quartersId);
    setCompounds(temp);
  }, [selectedCategories, selectedSectors, selectedGroups, selectedSubSectors, year]);

  useEffect(() => {
    if (String(year).length === 4) {
      console.log(selectedSectors, selectedSubSectors, selectedGroups, selectedCategories, year);
      handleUpdate();
    }
  }, [selectedCategories, selectedSectors, selectedGroups, selectedSubSectors, year]);
  // ===== CATEGORIA END ======

  // --- watching the selected compound for details -----
  const [selectedCompoundForDetails, setSelectedCompoundForDetails] = useState(null);

  // ---- watching the selected compound for details -----

  // --- MODAL -----
  const [modalOpen, modalSetOpen] = useState(false);
  const [modalData, setModalData] = useState([]);

  const getModalData = useCallback(async () => {
    let searchData = {
      year: year,
      sectorsId: selectedSectors,
      subsectorsId: selectedSubSectors,
      groupsId: selectedGroups,
      categoriesId: selectedCategories,
      molecularCompound: selectedCompoundForDetails,
    };
    var temp = await reportMolecularCompoundDetail(searchData);
    setModalData(temp);
  }, [selectedCompoundForDetails]);

  useEffect(() => {
    if (modalOpen) {
      getModalData();
    } else {
      setModalData([]);
    }
  }, [modalOpen]);
  // --- MODAL END-----

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <TitleCustom
        title={"Resumen Por Principio Activo"}
        excelData={getExcelData(compounds)}
        excelName={"Reporte_Por_Principio_Activo_" + year + ".xlsx"}
      ></TitleCustom>

      <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
        <Grid container>
          <Grid item>
            <MDInput type="number" label="Year" value={year} onChange={handleYear} />
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item>
            <MultipleSelectChip
              key="Sector"
              label="Sector"
              data={getSector(catalogSector)}
              onChange={handleSectorDataChange}
            />
          </Grid>
          <Grid item>
            <MultipleSelectChip
              key="SubSector"
              label="SubSector"
              data={getSubSector(selectedSectors, catalogSubSector)}
              onChange={handleSubSectorDataChange}
            />
          </Grid>
          <Grid item>
            <MultipleSelectChip
              key="Grupo"
              label="Grupo"
              data={getGrupos(selectedSubSectors, catalogGroups)}
              onChange={handleGruposDataChange}
            />
          </Grid>
          <Grid item>
            <MultipleSelectChip
              key="Categoria"
              label="Categoria"
              data={getCategories(selectedGroups, catalogCategories)}
              onChange={handleCategoryDataChange}
            />
          </Grid>
        </Grid>
      </MDBox>
      <br />

      <DataTable
        table={getTableData(compounds, modalSetOpen, setSelectedCompoundForDetails)}
        canSearch={true}
      />
      <div>
        {modalOpen && modalData.length > 0 ? (
          <>
            <DetailsDialog
              open={modalOpen}
              setOpen={modalSetOpen}
              modalData={modalData}
            ></DetailsDialog>
          </>
        ) : (
          ""
        )}
      </div>

      <Footer />
    </DashboardLayout>
  );
}

export default PorPrincipioActivo;
